export const API_ENDPOINTS = {
  // Users
  GET_USER_DETAILS: `/api/users/get-user-details`,
  CREATE_USER: `/api/users/create-user`,
  LOGIN: `/api/users/login`,
  UPDATE_USER_PROFILE: `/api/users/update-profile`,
  GET_CLI_OPTIONS: `/api/users/cli-options`,
  GET_SIGNUP_CLI_OPTIONS: `/api/users/signup-cli-options`,

  // Topics
  GET_ALL_TOPICS: `/api/topic/get-all-topics`,
  CREATE_TOPIC: `/api/topic/create-topic`,
  CREATE_SUBTOPIC: `/api/topic/create-subtopic`,
  DELETE_TOPIC_BY_NAME: `/api/topic/delete-topic`, // Append /:topicName
  DELETE_SUBTOPIC_BY_NAME: `/api/topic/delete-subtopic`, // Append /:topicName/:subtopicName
  RENAME_TOPIC_BY_NAME: `/api/topic/rename-topic`, // Append /:topicName
  RENAME_SUBTOPIC_BY_NAME: `/api/topic/rename-subtopic`, // Append /:topicName/:subtopicName

  // Admin Dashboard & Analytics
  GET_DASHBOARD_OVERVIEW: `/api/admin/get-dashboard-overview`,
  GET_ADMIN_ANALYTICS: `/api/admin/get-admin-analytics`,
  GET_QUIZ_CHART: `/api/admin/get-quiz-chart`,
  GET_PARTICIPANTS: `/api/admin/participants`,
  GET_DASHBOARD_GRAPHS: `/api/admin/dashboard-graphs`,
  GET_LEADERBOARD_DATA: `/api/admin/leaderboard-data`,
  GET_CERTIFICATION_LEADERBOARD: `/api/admin/certification-leaderboard`,

  // Certificate Templates
  GET_CERTIFICATE_TEMPLATES: `/api/certificate-templates`,
  PREVIEW_CERTIFICATE_TEMPLATE: `/api/certificate-templates/preview`,
  CREATE_CERTIFICATE_TEMPLATE: `/api/certificate-templates`,
  UPDATE_CERTIFICATE_TEMPLATE: `/api/certificate-templates`, // Append /:templateId

  // Questions
  GET_ALL_QUESTIONS: `/api/questions/get-all-questions`,
  DELETE_QUESTION: `/api/questions/delete-ques`, // Append /:questionId
  GET_QUESTION: `/api/questions/get-question`, // Append /:questionId
  UPDATE_QUESTION: `/api/questions/update-ques`, // Append /:questionId
  ADD_QUESTION: `/api/questions/add-question`,
  BULK_UPLOAD_QUESTIONS: `/api/questions/bulk-upload`,

  // Quiz
  CREATE_QUIZ: `/api/quiz/create-quiz`,
  DELETE_QUIZ: `/api/quiz/delete-quiz`, // Append /:quizToDelete?quizId=...
  UPDATE_QUIZ: `/api/quiz/update-quiz`, // Append /:quizId
  GET_QUIZES: `/api/quiz/get-quizes`,
  GET_QUESTIONS_BY_QUIZ: `/api/quiz/get-questions`, // Append /:quizId
  GET_ATTEMPTED_USERS: `/api/quiz/get-attempted-users`, // Append /:quizId
  LOCK_CERTIFICATION_SELECTION: `/api/quiz/certification-selection`, // Append /:quizId

  // Reports
  QUIZ_REPORTS: `/api/quiz-reports`,
  SUBMIT_QUIZ_REPORT: `/api/submit-quiz-report`,
  DOWNLOAD_CERTIFICATE: `/api/certificate`, // Append /:reportId/download
};
